import {HttpParams} from '@angular/common/http';
import {EventEmitter, Injectable} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Observable, of, Subject} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {Endpoints} from '../../../models/endpoints';
import {Constants} from '../generic/models/constants';
import {InformationComponent} from '../modals/information/information.component';
import {CompatibiliteMessage} from '../models/component-messages/compatibilite/compatibilite';
import {HttpService} from './http.service';
import {LogService} from './log.service';
import * as formEnabledJsonNoProd from '../../../../assets/data/forms_enabled/forms_enabled_noprod.json';
import * as formEnabledJsonProd from '../../../../assets/data/forms_enabled/forms_enabled_prod.json';
import {EnableMessage} from '../models/component-messages/enable/enable';
import {Avis} from '../../../models/avis';
import {ReferentielEformAvisLies} from '../../avisDePub/creer/models/referentielEformAvisLies';
import {environment} from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class CanNavigateInStepperService {

  constructor(private modalService: NgbModal,
              private http: HttpService) {
  }

  private LOG: LogService = new LogService(CanNavigateInStepperService);

  public currentNormeFormulaire;
  public currentFormulaire = null;
  public linkableForms: any[] = null;
  public linkableNotices: any[] = [];
  private selectedDiffuseur = [];
  public selectedDiffuseurAD = [];
  public selectedDiffuseurInitial = [];
  public formulairevalues = null;
  public intituleDiffuseur = [];
  public tempSelectedDiffuseur = [];
  public formsEnabledNoProd = JSON.stringify(formEnabledJsonNoProd);
  public formsEnabledProd = JSON.stringify(formEnabledJsonProd);
  public isCreerAvisLierSelected: boolean = false;
  public isAvisLierNational: boolean = false;
  public isEditAvisSelected: boolean = false;
  public isAvisParentSelected: boolean = false;
  public creerAvisLierSelected: boolean = false;
  public eformAllInputCreated: boolean = false;
  public selectedAvisItemData = null;
  public reference = null;
  public eformMotifChange = null;
  public eformCreatingChange: boolean = null;
  public eformIdPreviousForm: string = null;
  public eformIdParentNotice: string = null;
  public eformVersionPreviousForm: string = null;
  public referentielEformAvisLies: ReferentielEformAvisLies[];
  public isSHALorPS = null;
  public isBOAMPorJOUE = null;
  public currentValue: any = null;
  public isChoixFormulaire: boolean = false;
  public isEdit: boolean = false;
  public idParentFluxBoampEform = null;
  public isAvisLieCreate = false;
  public avisLieModalite = 0;
  public avisLieCreateFirstSave = false;
  public avisIdParent = null;

  private PRESSE_SPE = 'Presse specialisée';

  public compatibiliteMessage = new CompatibiliteMessage();
  public enableMessage = new EnableMessage();

  public subject = new Subject<boolean>();
  public isSelectedDiffuseurADMoreThanZero: boolean;

  // PRB0052503: F16->F29 5 lots - Perte de saisie des critères d'attribution et messages d'erreur non conformes
  public isCreationAvisLie: boolean = false;
  public avisFormCodeParent = null;

  public compatibilite: () => void;
  public enabledForms: () => boolean;

  diffReference = new EventEmitter<any>();
  private referenceParent = new EventEmitter<Avis>();
  private _referenceParent: Avis = null;
  formInfo = new EventEmitter<any>();

  private elementSource = new Subject<any>();
  element$ = this.elementSource.asObservable();

  sendElement(element: any) {
    this.elementSource.next(element);
  }

  syncParent() {
    this.referenceParent.subscribe(ref => this._referenceParent = ref);
  }

  getReferenceParent(): Avis {
    if (!this._referenceParent) this.syncParent();
    return this._referenceParent;
  }

  setReferenceParent(referenceParent: Avis) {
    if (!this._referenceParent) this.syncParent();
    this.referenceParent.emit(referenceParent);
  }

  subReferenceParent(): EventEmitter<Avis> {
    return this.referenceParent;
  }

  canNavigate(index, form, previous?): Observable<boolean> {
    switch (index) {
      case 0.3: {
        return this.coherence(form, previous);
      }
      default: {
        return of(true);
      }
    }
  }

  canGoTo(index, desireIndex): boolean {
    //On ne doit pas pouvoir naviguer depuis/jusqu'a l'etape 0
    return !index.toString().startsWith('0') && !desireIndex?.toString().startsWith('0');
  }

  canNext(index, form, isBOAMPorJOUESaved, fadIndex, annonceurIndex): Observable<boolean> {
    switch (index) {
      case 0.2: {
        if (this.currentFormulaire.includes('E_FORM') && this.isAvisParentSelected) {
          this.openModal(this.compatibiliteMessage.MOD2);
        }
        if (this.enabledForms() === false) {
          this.openModal(this.enableMessage.maintenance);
          return of(false);
        } else {
          return of((form.controls.formIntitule.value !== undefined && form.controls.formIntitule.value !== ''
            || (this.currentFormulaire)) !== '' && (!this.linkableNotices.length || this.referenceParent != null));
        }
      }
      case 0.3: {
        if (this.currentNormeFormulaire === 'NATIONAL' && !this.selectedDiffuseur.includes('NATIONAL')) {
          this.openModal(this.compatibiliteMessage.M042);
          return of(false);
        }
        return of(this.intituleDiffuseur.length > 0 || (this.currentFormulaire) != '');
      }
      default: {
        return of(true);
      }
    }
  }

  openModal(message) {
    const modalRef = this.modalService.open(InformationComponent);
    modalRef.componentInstance.title = '';
    modalRef.componentInstance.content = message;
  }

  verifyAnnonceur(form: FormGroup, isBOAMPorJOUESaved: boolean): Observable<boolean> {
    if (((isBOAMPorJOUESaved && this.isBOAMPorJOUE === null) || (this.isBOAMPorJOUE !== null && this.isBOAMPorJOUE)) && environment.check_announcer !== 'false') {
      const annonceur = new HttpParams()
        .set('login', encodeURIComponent(form.controls._SepSep_idAnnonceur_SepAtt_idannonceurboampweb?.value))
        .set('mdp', encodeURIComponent(form.controls._SepSep_idAnnonceur_SepAtt_mdpboampweb?.value))
        .set('mail', encodeURIComponent(form.controls._SepSep_idAnnonceur_SepAtt_mailcontactboampweb?.value));
      return this.http.get(Endpoints.ADMIN_ENDPOINT + Endpoints.ANN_VERIF, null, {httpParams: annonceur}).pipe(map(data => {
          return data == true;
        }
      ));
    } else {
      return of(true);
    }
  }

  /**
   * Vérifie qu'un avis lié est envoyé avec le compte annonceur de l'avis auquel il est lié : la DILA rejette sinon
   * l'avis ("L'identifiant de procédure que vous avez renseigné existe déjà pour un autre client").
   *
   * @param form Le formulaire où on récupère le login de l'annonceur
   * @param referenceAvis La référence de l'avis lié
   * @returns Un observable de type boolean. False si le compte annonceur est différent, true sinon.
   */
  verifyAnnonceurAvisLie(form: FormGroup, referenceAvis: string): Observable<boolean> {
    const loginAnnonceur = form.controls._SepSep_idAnnonceur_SepAtt_idannonceurboampweb?.value;
    if (!loginAnnonceur) {
      return of(true);
    }
    const infoAnnonceurAvisLie = {
      referenceAvis: referenceAvis ?? null,
      referenceAvisLie: this.getReferenceParent()?.reference ?? null,
      loginAnnonceur: loginAnnonceur
    };
    return this.http.post(Endpoints.AVIS_LIE_ANNONCEUR_CHECK, infoAnnonceurAvisLie).pipe(
      map(data => data !== false),
      // Une erreur technique ne bloque pas l'envoi : le contrôle est refait côté serveur à la validation
      catchError(error => {
        this.LOG.error(error);
        return of(true);
      })
    );
  }

  mockedCompatibilite(fn: () => void) {
    this.compatibilite = fn;
  }

  mockedEnabledForms(fn: () => boolean) {
    this.enabledForms = fn;
  }

  isSelectedDiffuseurEmpty() {
    return this.selectedDiffuseur?.length === 0;
  }

  tryToGetDiffIdByFlux(form) {
    this.getDiffuseurAlreadySelected(form);
  }

  getDiffuseurAlreadySelected(form) {
    // clear cache
    this.selectedDiffuseur = [];
    this.selectedDiffuseurAD = [];
    this.intituleDiffuseur = [];

    this.tempSelectedDiffuseur.forEach(diffId => {
      this.getDiffuseurChildAndParentByKey(form, diffId.toString(), true);
    });

  }

  getDiffuseurChildAndParentByKey(form, key, isFlux?) {
    const diffFormGrp: any = form.get(Constants.TABLE_DATA_CTRL_NAME);
    const diffsCtrl: any = diffFormGrp.controls;
    const childrens = diffsCtrl[key.toString()]?.controls?.children?.controls;
    // if (childrens != null && childrens != undefined) {
    //   Object.keys(childrens).forEach(key => {
    //     const isChecked = childrens[key].controls.checked.value;

    //     if (isChecked){
    //       this.selectedDiffuseur.push(childrens[key].controls.format.value !== this.PRESSE_SPE ? childrens[key].controls.zonediffusion.value : childrens[key].controls.format.value);
    //       childrens[key].controls.diffuseur.value ? this.intituleDiffuseur.push(childrens[key].controls.diffuseur.value) : '';

    //     } else if (isFlux != undefined && isFlux != null) {
    //       childrens[key].controls.checked.value = true;
    //       this.selectedDiffuseur.push(childrens[key].controls.format.value !== this.PRESSE_SPE ? childrens[key].controls.zonediffusion.value : childrens[key].controls.format.value);
    //       childrens[key].controls.diffuseur.value ? this.intituleDiffuseur.push(childrens[key].controls.diffuseur.value) : '';
    //     }
    //   });
    // }
    if (diffsCtrl[key]?.controls?.checked?.value) {
      this.selectedDiffuseur.push(diffsCtrl[key].controls.zonediffusion.value);
      if (diffsCtrl[key].controls.diffuseur.value) {
        this.intituleDiffuseur.push(diffsCtrl[key].controls.diffuseur.value);
      }
    }
    if (isFlux != undefined && isFlux != null && diffsCtrl[key]?.controls?.checked?.value == false) {
      diffsCtrl[key].controls.checked.value = true;
      this.selectedDiffuseur.push(diffsCtrl[key].controls.zonediffusion.value);
      if (diffsCtrl[key].controls.diffuseur.value) {
        this.intituleDiffuseur.push(diffsCtrl[key].controls.diffuseur.value);
      }
    }


    this.isSelectedDiffuseurAD();
  }

  getDiffuseur(form) {
    Object.keys(form.controls.tableDataCtrlName.controls).forEach(key => {
      this.getDiffuseurChildAndParentByKey(form, key);
    });
  }

  isSelectedDiffuseurAD() {
    this.selectedDiffuseurAD = [];
    this.selectedDiffuseur.forEach(dif => {
      if (dif != 'EUROPE' && dif != 'NATIONAL') {
        this.selectedDiffuseurAD.push(dif);
      }
    });

    if (this.selectedDiffuseurAD.length > 0) {
      this.isSelectedDiffuseurADMoreThanZero = true;
    } else {
      this.isSelectedDiffuseurADMoreThanZero = false;
    }
  }

  isSelectedDiffuseurADTemp(idBoamp, idJoue) {
    const selectedDiffuseurADTemp = [];
    this.tempSelectedDiffuseur.forEach(dif => {
      if (dif != idBoamp && dif != idJoue) {
        selectedDiffuseurADTemp.push(dif);
      }
    });
    if (selectedDiffuseurADTemp.length > 0) {
      this.isSelectedDiffuseurADMoreThanZero = true;
    } else {
      this.isSelectedDiffuseurADMoreThanZero = false;
    }
  }

  coherence(form, previous?): Observable<boolean> {

    if (previous !== undefined) {
      return of(true);
    }

    this.selectedDiffuseur = [];
    this.selectedDiffuseurAD = [];
    this.intituleDiffuseur = [];

    this.getDiffuseur(form);

    const containsJOUE = this.selectedDiffuseur.includes('EUROPE');
    const containsBOAMP = this.selectedDiffuseur.includes('NATIONAL');
    const containsSHAL = this.selectedDiffuseur.filter(f => f !== 'EUROPE' && f !== 'NATIONAL' && f !== this.PRESSE_SPE).length > 0;
    const containsPS = this.selectedDiffuseur.includes(this.PRESSE_SPE);

    // Partie Annonceur
    this.isBOAMPorJOUE = containsBOAMP || this.selectedDiffuseur.includes('EUROPE');
    this.isSHALorPS = containsSHAL || containsPS;
    this.isSelectedDiffuseurAD();

    if (this.selectedDiffuseur.length > 0) {
      switch (this.currentNormeFormulaire) {
        case 'EUROPEEN': {
          if ((containsBOAMP || containsSHAL || containsPS) && !containsJOUE) {
            const modalRef = this.modalService.open(InformationComponent);
            if (containsBOAMP) {
              modalRef.componentInstance.title = this.compatibiliteMessage.titlecompatibilite;
              modalRef.componentInstance.content = this.compatibiliteMessage.M09;
              modalRef.componentInstance.OkOuRetour = true;
            }
            if (containsSHAL) {
              modalRef.componentInstance.title = this.compatibiliteMessage.titlecompatibilite;
              modalRef.componentInstance.content = this.compatibiliteMessage.M010;
              modalRef.componentInstance.OkOuRetour = true;
            }
            if (containsPS) {
              modalRef.componentInstance.title = this.compatibiliteMessage.titlecompatibilite;
              modalRef.componentInstance.content = this.compatibiliteMessage.M037;
              modalRef.componentInstance.OkOuRetour = true;
            }
            return modalRef.dismissed.pipe(map((reason: boolean) => {
              return reason;
            }));
          }
        }
        case 'NATIONAL': {
          if (containsPS && !containsBOAMP) {
            const modalRef = this.modalService.open(InformationComponent);
            modalRef.componentInstance.title = this.compatibiliteMessage.titlecompatibilite;
            modalRef.componentInstance.content = this.compatibiliteMessage.M038;
            modalRef.componentInstance.OkOuRetour = true;
            return modalRef.dismissed.pipe(map((reason: boolean) => {
              return reason;
            }));
          }
        }
        case 'LIBRE': {
        }
        case 'ADAPTE': {
        }
        default: {
          return of(true);
        }
      }
    } else {
      return of(false);
    }

  }


}
